export default __webpack_public_path__ + "static/media/logo.2669a26a.svg";